/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Styled components for TariffsAndServicesFilter
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.4.0
 */

import styled from 'styled-components';

import { FlexStyled } from '@components/common/Block/Flexbox';
import { ONBOARDING_DATA_ATTR } from '@modules/onboarding/onboardingConstants';
import { EOnboardingComponentsId } from '@modules/onboarding/types/onboardingTypes';
import { colors } from '@theme/index';

export const TariffsAndServicesFilterRegionStyled = styled.div.attrs({
    [ONBOARDING_DATA_ATTR]: EOnboardingComponentsId.productFilterRegion,
    role: 'select',
})`
    border-left: 1px solid ${colors.borderColorDisabled};

    > div {
        width: 218px;
    }

    .input__container.select__search-input {
        margin: 12px;
        width: auto;
    }

    .drop-down-filter__filter-button .disabled .arrow-tooltip__text {
        color: ${colors.textColorOpacity};
    }
`;

export const TariffsAndServicesFilterPaymentStyled = styled.div`
    border-left: 1px solid ${colors.borderColorDisabled};

    > div {
        width: 188px;
    }
`;

export const ProductsFilterShowSelectedOnlyStyled = styled.div`
    border-left: 1px solid ${colors.borderColorDisabled};

    > div {
        width: 120px;
    }
`;

export const TariffsAndServicesFilterContainerStyled = styled(FlexStyled)`
    & > *:not(:last-child) {
        margin-right: 12px;
    }

    & .select__select-drop-button {
        background-color: ${colors.tariffsAndServicesFilterButtonBgColor};
        border-color: ${colors.tariffsAndServicesFilterButtonBorderColor};
    }

    & .select__select-list {
        padding: 0;
        border-top: 1px solid ${colors.borderColorDisabled};
        box-sizing: content-box;
    }

    & .select__select-item {
        padding-right: 16px;
        &:focus,
        &:hover {
            background-color: ${colors.tariffsAndServicesFilterItemBgColorHover};
            color: ${colors.tariffsAndServicesFilterItemColorHover};
        }
    }
`;
